import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PageService } from '../services/page.service';
import { ClienteComponent } from '../../components/cliente/cliente.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { ModalInjectorService } from '../services/modal-injector.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-cambio-propiedad',
  templateUrl: './cambio-propiedad.component.html',
  styleUrls: ['./cambio-propiedad.component.css'],
})
export class CambioPropiedadComponent implements OnInit, AfterContentChecked {
  @ViewChild('vendedor', { static: false }) vendedor: ClienteComponent;
  @ViewChild('comprador', { static: false }) comprador: ClienteComponent;
  datosVehiculos: FormGroup;
  documentos: FormGroup;
  isEditable = false;
  isEditable1 = false;
  isEditable2 = false;
  isEditable3 = false;
  datoTramite: any;
  DatosClienteVendedor: any;
  tipoVendedor: {};
  tipoComprador: {};
  tipoCliente: any;
  tipo: string;
  ok = false;
  idSolicitud: any;
  formData: FormData;
  observacion: any;
  hoy = new Date();
  clasif: any;
  spinnerEITV = false;

  constructor(
    private cdRef: ChangeDetectorRef,
    private fb: FormBuilder,
    private servicio: PageService,
    private snackbar: MatSnackBar,
    private router: Router,
    private date: DatePipe,
    public dialog: MatDialog,
    private modalInjector: ModalInjectorService
  ) {}

  ngOnInit(): void {
    console.log('Entro en el cambio de propiedad');
    this.inicio();
  }

  ngAfterContentChecked(): void {
    this.cdRef.detectChanges();
  }

  get clienteComprador(): any {
    return this.comprador ? this.comprador.cliente$ : null;
  }

  get clienteVendedor(): any {
    return this.vendedor ? this.vendedor.cliente$ : null;
  }

  get matriculaNoValido(): any {
    return (
      this.datosVehiculos.get('matricula').invalid &&
      this.datosVehiculos.get('matricula').touched
    );
  }

  get bastidorNoValido(): any {
    return (
      this.datosVehiculos.get('bastidor').invalid &&
      this.datosVehiculos.get('bastidor').touched
    );
  }

  get marcaNoValido(): any {
    return (
      this.datosVehiculos.get('marca').invalid &&
      this.datosVehiculos.get('marca').touched
    );
  }

  get modeloNoValido(): any {
    return (
      this.datosVehiculos.get('modelo').invalid &&
      this.datosVehiculos.get('modelo').touched
    );
  }

  get baseNoValido(): any {
    return (
      this.datosVehiculos.get('baseImponible').invalid &&
      this.datosVehiculos.get('baseImponible').touched
    );
  }

  inicio(): void {
    this.tipoCliente = sessionStorage.getItem('tipoCliente');
    this.idSolicitud = sessionStorage.getItem('id');
    if (sessionStorage.getItem('colaborador') === 'null') {
      this.router.navigate(['page/home']);
    }
    if (this.idSolicitud !== 'null') {
      console.log('hay idSolicitud');
      this.getSolicitud();
    }
    if (this.idSolicitud === 'null') {
      console.log('No hay idSolicitud');
      if (this.tipoCliente === 'null') {
        this.router.navigate(['page/home']);
      } else {
        this.getDatos();
      }
    }
    this.clasificaciones();
    this.crearFormulario();
  }

  crearFormulario(): any {
    this.datosVehiculos = this.fb.group({
      tipo: '',
      colaborador: '',
      usuarioweb: '',
      matricula: ['', [Validators.required]],
      bastidor: ['', [Validators.required]],
      tipoVehiculo: '10',
      marca: '',
      modelo: '',
      servicioalquesedestina: 'B00 - PART-SIN ESPECIFICAR',
      exencion: '0',
      cargas: '',
      baseImponible: [null, [Validators.required]],
      nroVentas: '',
      fechaMatriculacion: null,
      cilindrada: ['', [Validators.required]],
      potenciaFiscal: ['', [Validators.required]],
      cv: ['', [Validators.required]],
      co2: '',
    });
  }

  async getDatos(): Promise<void> {
    await this.servicio
      .getCliente(sessionStorage.getItem('nifColaborador'))
      .subscribe(
        (res) => {
          console.log('Respuesta getColaborador:', res);
          if (this.tipoCliente === '1') {
            this.tipoVendedor = res;
            this.tipo = ' - Vendedor';
          }
          if (this.tipoCliente === '2') {
            this.tipoComprador = res;
            this.tipo = ' - Comprador';
          }
          if (this.tipoCliente === '3') {
            this.tipo = ' - Intermediario';
          }
          this.ok = true;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  getSolicitud(): void {
    this.servicio.getOneSolicitud(this.idSolicitud).subscribe(
      (res) => {
        this.setDato(res);
        this.tipoVendedor = {
          nif: res.nifVendedor,
          apellido1: res.apellido1Vendedor,
          apellido2: res.apellido2Vendedor,
          nombre: res.nombreVendedor,
          nifApoderado: res.nifApoderadoVendedor,
          apellido1Apoderado: res.apellido1ApoderadoVendedor,
          apellido2Apoderado: res.apellido2ApoderadoVendedor,
          nombreApoderado: res.nombreApoderadoVendedor,
          conceptoRepresentacionApoderado:
            res.conceptoRepresentacionApoderadoVendedor,
          fechaNacimiento: res.fechaNacimientoVendedor,
          sexo: res.sexoVendedor,
          email: res.emailVendedor,
          telefono: res.telefonoVendedor,
          enviarDocCorreo: res.enviarDocCorreoVendedor,
          provincia: res.provinciaVendedor,
          poblacion: res.poblacionVendedor,
          pueblo: res.puebloVendedor,
          cp: res.cpVendedor,
          tipoVia: res.tipoViaVendedor,
          direccion: res.direccionVendedor,
          direccionnumero: res.direccionnumeroVendedor,
          direccionpiso: res.direccionpisoVendedor,
          direccionpuerta: res.direccionpuertaVendedor,
        };
        console.log(this.tipoVendedor);
        this.tipoComprador = {
          nif: res.nif,
          apellido1: res.apellido1,
          apellido2: res.apellido2,
          nombre: res.nombre,
          nifApoderado: res.nifApoderado,
          apellido1Apoderado: res.apellido1Apoderado,
          apellido2Apoderado: res.apellido2Apoderado,
          nombreApoderado: res.nombreApoderado,
          conceptoRepresentacionApoderado: res.conceptoRepresentacionApoderado,
          fechaNacimiento: res.fechaNacimiento,
          sexo: res.sexo,
          email: res.email,
          telefono: res.telefono,
          enviarDocCorreo: res.enviarDocCorreo,
          provincia: res.provincia,
          poblacion: res.poblacion,
          pueblo: res.pueblo,
          cp: res.cp,
          tipoVia: res.tipoVia,
          direccion: res.direccion,
          direccionnumero: res.direccionnumero,
          direccionpiso: res.direccionpiso,
          direccionpuerta: res.direccionpuerta,
          direccionBloque: res.direccionBloque,
          direccionEscalera: res.direccionEscalera,
        };
        console.log(this.tipoComprador);
        this.ok = true;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  setDato(datos): any {
    this.datosVehiculos.controls.matricula.setValue(datos.matricula);
    this.datosVehiculos.controls.bastidor.setValue(datos.bastidor);
    if (datos.tipoVehiculo !== null) {
      const clasif = datos.tipoVehiculo.slice(0, 2);
      this.datosVehiculos.controls.tipoVehiculo.setValue(clasif);
      console.log(this.datosVehiculos.value.tipoVehiculo);
    } else {
      this.datosVehiculos.controls.tipoVehiculo.setValue('10');
    }
    this.datosVehiculos.controls.marca.setValue(datos.marca);
    this.datosVehiculos.controls.modelo.setValue(datos.modelo);
    this.datosVehiculos.controls.servicioalquesedestina.setValue(
      datos.servicioalquesedestina
    );
    const exencion = this.getRespuesta(datos.exencion);
    this.datosVehiculos.controls.exencion.setValue(exencion);
    this.datosVehiculos.controls.cargas.setValue(datos.cargas);
    this.datosVehiculos.controls.baseImponible.setValue(datos.baseImponible);
    this.datosVehiculos.controls.nroVentas.setValue(datos.NroVentas);
    this.datosVehiculos.controls.fechaMatriculacion.setValue(
      datos.fechaMatriculacion
    );
    this.datosVehiculos.controls.cilindrada.setValue(datos.cilindrada);
    this.datosVehiculos.controls.potenciaFiscal.setValue(datos.potenciaFiscal);
    this.datosVehiculos.controls.cv.setValue(datos.cv);
    this.datosVehiculos.controls.co2.setValue(datos.co2);
  }

  getRespuesta(condition): string {
    let v = '';
    switch (condition) {
      case false:
        v = '0';
        break;
      case true:
        v = '1';
        break;
    }
    return v;
  }

  getVehiculo(): void {
    if (this.datosVehiculos.value.matricula.length > 5) {
      this.servicio
        .getOneVehiculo(this.datosVehiculos.value.matricula)
        .subscribe(
          (res) => {
            console.log(res);
            if (res.matricula === this.datosVehiculos.value.matricula) {
              if (res.vehiculo != null) {
                this.setDatos(res.vehiculo);
              } else {
                this.datosVehiculos.setValue({
                  tipo: '',
                  colaborador: '',
                  matricula: this.datosVehiculos.value.matricula
                    ?.toUpperCase()
                    .trim(),
                  usuarioweb: '',
                  bastidor: '',
                  tipoVehiculo: '10',
                  marca: '',
                  modelo: '',
                  servicioalquesedestina: 'B00 - PART-SIN ESPECIFICAR',
                  exencion: '0',
                  cargas: '',
                  baseImponible: null,
                  nroVentas: '',
                  fechaMatriculacion: null,
                  cilindrada: '',
                  potenciaFiscal: '',
                  cv: '',
                  co2: null,
                });
              }
            }
          },
          (error) => {
            console.log(error);
          }
        );
    } else if (this.datosVehiculos.value.matricula.length < 4) {
      this.datosVehiculos.setValue({
        tipo: '',
        colaborador: '',
        matricula: this.datosVehiculos.value.matricula?.toUpperCase().trim(),
        usuarioweb: '',
        bastidor: '',
        tipoVehiculo: '10',
        marca: '',
        modelo: '',
        servicioalquesedestina: 'B00 - PART-SIN ESPECIFICAR',
        exencion: '0',
        cargas: '',
        baseImponible: null,
        nroVentas: '',
        fechaMatriculacion: null,
        cilindrada: '',
        potenciaFiscal: '',
        cv: '',
        co2: null,
      });
    }
  }

  setDatos(datos): any {
    this.datosVehiculos.controls.matricula.setValue(datos.matricula);
    this.datosVehiculos.controls.bastidor.setValue(datos.bastidor);
    this.datosVehiculos.controls.marca.setValue(datos.marca);
    this.datosVehiculos.controls.modelo.setValue(datos.modelo);
    if (datos.clasificacion !== null) {
      const clasif = datos.clasificacion.slice(0, 2);
      this.datosVehiculos.controls.tipoVehiculo.setValue(clasif);
      console.log(this.datosVehiculos.value.tipoVehiculo);
    } else {
      this.datosVehiculos.controls.tipoVehiculo.setValue('10');
    }
    this.datosVehiculos.controls.servicioalquesedestina.setValue(
      datos.servicioalquesedestina
    );
    this.datosVehiculos.controls.baseImponible.setValue(datos.baseImponible);
    this.datosVehiculos.controls.fechaMatriculacion.setValue(
      datos.fechaMatriculacion
    );
    this.datosVehiculos.controls.potenciaFiscal.setValue(datos.hp);
    this.datosVehiculos.controls.cv.setValue(datos.potencianetaitv);
    this.datosVehiculos.controls.cilindrada.setValue(datos.cilindrada);
    this.datosVehiculos.controls.co2.setValue(datos.co2);

    this.snackbar.open(
      'Información del vehículo autocompletada, por favor, revise los datos.',
      'OK',
      {
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: 'snack-cliente',
        duration: 3500,
      }
    );
  }

  siguiente(): void {
    this.datosVehiculos.controls.fechaMatriculacion.setValue(
      this.date.transform(
        this.datosVehiculos.value.fechaMatriculacion,
        'yyyy-MM-dd'
      )
    );
    console.log(this.datosVehiculos.value);
    this.isEditable = true;
  }

  siguiente2($event: any): void {
    this.DatosClienteVendedor = {
      nifVendedor: $event.nif,
      apellido1Vendedor: $event.apellido1,
      apellido2Vendedor: $event.apellido2,
      nombreVendedor: $event.nombre,
      nifApoderadoVendedor: $event.nifApoderado,
      apellido1ApoderadoVendedor: $event.apellido1Apoderado,
      apellido2ApoderadoVendedor: $event.apellido2Apoderado,
      nombreApoderadoVendedor: $event.nombreApoderado,
      conceptoRepresentacionApoderadoVendedor:
        $event.conceptoRepresentacionApoderado,
      fechaNacimientoVendedor: $event.fechaNacimiento,
      sexoVendedor: $event.sexo,
      emailVendedor: $event.email,
      telefonoVendedor: $event.telefono,
      enviarDocCorreoVendedor: $event.enviarDocCorreo,
      provinciaVendedor: $event.provincia,
      poblacionVendedor: $event.poblacion,
      puebloVendedor: $event.pueblo,
      cpVendedor: $event.cp,
      tipoViaVendedor: $event.tipoVia,
      direccionVendedor: $event.direccion,
      direccionnumeroVendedor: $event.direccionnumero,
      direccionpisoVendedor: $event.direccionpiso,
      direccionpuertaVendedor: $event.direccionpuerta,
      direccionBloqueVendedor: $event.direccionBloque,
      direccionEscaleraVendedor: $event.direccionEscalera,
    };
    console.log(this.DatosClienteVendedor);
    this.isEditable1 = true;
  }

  siguiente3($event: any): void {
    this.datoTramite = {
      ...$event,
      ...this.DatosClienteVendedor,
      ...this.datosVehiculos.value,
    };
    const c = this.clasif.find(
      (res) => res.id === this.datosVehiculos.value.tipoVehiculo
    );
    this.datoTramite.tipoVehiculo = c.descripcion;
    this.datoTramite.tipo = 'CAMBIO DE PROPIEDAD';
    this.datoTramite.numPedido = sessionStorage.getItem('numPedido');
    this.datoTramite.tipoTramite = sessionStorage.getItem('tipoTramite');
    this.datoTramite.justificante = sessionStorage.getItem('justificante');
    this.datoTramite.colaborador = sessionStorage.getItem('colaborador');
    this.datoTramite.usuarioweb = sessionStorage.getItem('email');
    console.log('DatoTramite completo', this.datoTramite);
    this.isEditable2 = true;
    this.isEditable3 = true;
  }

  clasificaciones(): void {
    this.clasif = [
      { id: '03', descripcion: '03xx –CICLOMOTOR' },
      { id: '04', descripcion: '04xx – MOTOCICLETA' },
      { id: '06', descripcion: '06xx – AUTOMOVIL DE TRES RUEDAS' },
      { id: '10', descripcion: '10xx – TURISMO' },
      { id: '17', descripcion: '17xx – PICK UP' },
      { id: '20', descripcion: '20xx – CAMION MMA <=3.500 kg' },
      { id: '21', descripcion: '21xx – CAMION 3.500 kg. < MMA <= 12.500 kg' },
      { id: '22', descripcion: '22xx – CAMION MMA > 12.000 kg' },
      { id: '24', descripcion: '24xx – FURGON/FURGONETA MMA <= 3.500 kg' },
      { id: '31', descripcion: '31xx – VEHICULO MIXTO ADAPTABLE' },
      { id: '32', descripcion: '32xx – AUTO-CARAVANA MMA <= 3.500 kg' },
      { id: '33', descripcion: '33xx – AUTO-CARAVANA MMA > 3.500 kg' },
      { id: '66', descripcion: '66xx – QUAD ATV' },
    ];
  }

  getDatosEITV(): void {
    if (
      this.datosVehiculos.get('bastidor').value == '' ||
      this.datosVehiculos.get('bastidor').invalid
    ) {
      Swal.fire(
        '',
        'Se necesita un bastidor válido para recuperar los datos del vehículo desde la DGT',
        'warning'
      );
    } else {
      this.spinnerEITV = true;
      this.servicio
        .getEITV(this.datosVehiculos.get('bastidor').value)
        .subscribe({
          next: (value) => {
            console.log(value.content);
            if (value.error == 'ERROR')
              Swal.fire(
                '',
                'Error recuperando los datos: ' +
                  value.content +
                  '. Por favor rellene manualmente los datos.',
                'warning'
              );
            else Swal.fire('', 'Datos EITV recuperados con éxito', 'success');
            console.log(value.content.datos.EMISION_CO2);
            this.datosVehiculos.controls.co2.setValue(
              (parseInt(value.content.datos.EMISION_CO2) / 1000).toFixed(0)
            );
            this.datosVehiculos.controls.tipoVehiculo.setValue(
              value.content.datos.CLASIFICACION_VEHICULO.slice(0, 2)
            );
            this.datosVehiculos.controls.cv.setValue(
              (parseInt(value.content.datos.POTENCIA_NETA) / 1000).toString()
            );
            //this.datosVehiculos.controls.cv.setValue((parseInt(value.content.datos.POTENCIA_NETA)/1000).toFixed(3).toString().padStart(13,"0"));
            this.datosVehiculos.controls.potenciaFiscal.setValue(
              value.content.datos.POTENCIA_FISCAL / 100
            );
            this.datosVehiculos.controls.cilindrada.setValue(
              value.content.datos.CILINDRADA.replace(/^0+/, '')
            );
            this.datosVehiculos.controls.marca.setValue(
              value.content.datos.MARCA
            );
            this.datosVehiculos.controls.modelo.setValue(
              value.content.datos.MODELO
            );
            //this.datosVehiculos.controls.matricula.setValue(value.content.datos.MATRICULA);
          },
          error: (err) => {
            console.log(err);
            Swal.fire(
              '',
              'Imposible conectar con la DGT, por favor compruebe el bastidor y si es correcto rellene manualmente los datos del vehículo',
              'warning'
            );
          },
          complete: () => {
            this.spinnerEITV = false;
          },
        });
    }
  }
}
